/**
 * App-wide toast from anywhere (e.g. a message action sheet or the sticker
 * maker layer) without threading `setToast` through every component.
 * The listener lives in useAppBootstrap and feeds the shell's toast.
 */
export const APP_TOAST_EVENT = "veto:toast";

export function showAppToast(text: string): void {
  if (typeof window === "undefined" || !text) return;
  window.dispatchEvent(new CustomEvent<string>(APP_TOAST_EVENT, { detail: text }));
}
